import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-location-view d-flex flex-grow-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "location-container" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import Mapbox, { Marker, Popup } from "mapbox-gl";
import { Constants } from "@/classes/constants";
import { onMounted, onUnmounted, watch } from "vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'MapLocationPicker',
  props: {
	modelValue: {
		type: Array,
		default: ()=>[0,0] as Array<number>
	}
},
  emits: ["update:modelValue"],
  setup(__props, { expose, emit: emits }) {

const props = __props;

let map: Mapbox.Map;
let marker: Marker;
let didZoomToInitialMaker = false;
// const mapType = ref<"satellite" | "map">("map");




let modelWatchStopHandle: any;

onMounted(() => {
	Mapbox.accessToken = Constants.mapBoxAPIKey;
	map = new Mapbox.Map({
		container: "location-container",
		style: Constants.projectsMapStyle,
		center: [0,0],
		zoom: 3,
	});

	// disable map rotation using right click + drag
	map.dragPan.disable();
	map.dragRotate.disable();

	// disable map rotation using touch rotation gesture
	map.touchZoomRotate.disableRotation();

	//Switch controls to be panned by right mouse button
	var isMoving = false;
	var offset;
	map.on("contextmenu", () => { return undefined; });
	map.on("mousedown", (e) => {
		if (e.originalEvent.button === 1 || e.originalEvent.button === 2) {
			isMoving = true;
			offset = e.point;
		}
	});
	map.on("mousemove", (e) => {
		if (isMoving) {
			map.panBy([offset.x - e.point.x, offset.y - e.point.y], {
				duration: 0,
			});
			offset = e.point;
		}
	});
	map.on("mouseup", () => {
		isMoving = false;
	});
 
	var popup = new Popup({
		closeButton: false,
		closeOnClick: false
	});
	popup.setText("Drag to set location");
	popup.addTo(map);

	marker = new Marker({
		draggable: true,
		color: "#0096FF"
	});
	marker.setPopup(popup);
	try{
		marker.setLngLat([props.modelValue[1], props.modelValue[0]]);
	}catch{
		marker.setLngLat([0,0]);
	}
	marker.addTo(map);
	marker.on("dragend", ()=>{
		var center = marker.getLngLat();
		emits("update:modelValue", [center.lat,center.lng]);
	});

	function onDragEnd() {
		const lngLat = marker.getLngLat();
		console.log(`Longitude: ${lngLat.lng}<br />Latitude: ${lngLat.lat}`);
	}
 
	marker.on("dragend", onDragEnd);

	modelWatchStopHandle = watch(() => props.modelValue, onLocationChanged);

	if(!didZoomToInitialMaker){
		didZoomToInitialMaker = true;
		map.flyTo({ center: marker.getLngLat()});
	}
});

function setLocation(latLong: number[]){
	marker.setLngLat([latLong[1],latLong[0]])
}

function getLocation(){
	var lngLat = marker.getLngLat();
	return [lngLat.lat, lngLat.lng];
}

function onLocationChanged(value: any){
	var loc = marker.getLngLat();
	
	if(map && (loc.lat != value[0] || loc.lng != value[1])){
		try{
			marker.setLngLat([value[1], value[0]]);
		}catch(e){
			marker.setLngLat([0,0]);
		}
	}
	if(!didZoomToInitialMaker){
		didZoomToInitialMaker = true;
		map.flyTo({ center: marker.getLngLat()});
	}
}

onUnmounted(()=>{
	if(map){
		map.remove();
		map = null;
	}
	if(modelWatchStopHandle){
		modelWatchStopHandle();
		modelWatchStopHandle = null;
	}
});

expose({
	setLocation,
	getLocation
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})